// extracted by mini-css-extract-plugin
export default {"dcuiThemingErrorPage":"dcui-theming-error-page__dcui-theming-error-page__WGb4J"};